
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class GlitchPixelsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(50 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i + Math.floor(time * 10)) - 0.5) * width * 2.5;
                const ry = (this.pseudoRandom(i + 100 + Math.floor(time * 10)) - 0.5) * height * 2.5;
                const w = (10 + this.pseudoRandom(i) * 100) * scale;
                const h = (2 + this.pseudoRandom(i + 1) * 10) * scale;
                
                // Color shift (slight alpha variation)
                ctx.globalAlpha = (this.pseudoRandom(i + 2) * 0.5 + 0.5) / layerIndex;
                ctx.fillRect(rx, ry, w, h);
                
                // Vertical glitch
                if (this.pseudoRandom(i + 3) > 0.8) {
                    ctx.fillRect(rx, ry - 50 * scale, 2 * scale, 100 * scale);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
